import { render, staticRenderFns } from "./ManagerAddonFormGroup.vue?vue&type=template&id=31de81a6"
import script from "./ManagerAddonFormGroup.vue?vue&type=script&lang=ts"
export * from "./ManagerAddonFormGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31de81a6')) {
      api.createRecord('31de81a6', component.options)
    } else {
      api.reload('31de81a6', component.options)
    }
    module.hot.accept("./ManagerAddonFormGroup.vue?vue&type=template&id=31de81a6", function () {
      api.rerender('31de81a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/ManagerAddonFormGroup.vue"
export default component.exports